import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Typography,
  CircularProgress,
  IconButton,
  TextField,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSnackbar } from "notistack";
import styled from "styled-components";
import { AddSplitForInstrumentAction } from "../../../../services";
import FormItem from "../../../../components/FormItem";
import DateInput from "../../../../components/FormItem/DateInput";
import { DateFormat } from "../../../../settings";
import moment from "moment";

const SettingSubTitle = styled(Typography)`
  margin-bottom: 20px;
`;

const SettingButton = styled(Button)`
  background-color: #006dea;
  color: #fff;
`;
const Spinner = styled((props) => (
  <div {...props}>
    <CircularProgress />
  </div>
))`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 100000;
`;

const FromWrapper = styled.div`
  margin: 30px 0;
  .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    background-color: #ffffff !important;
  }
  .MuiSwitch-colorSecondary.Mui-checked {
    color: #006dea !important;
  }
`;

const UserIdList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const UserIdItems = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #f1f1f1;
  padding: 4px 5px;
  background: #006dea;
  border-radius: 4px;
  margin: 5px 2px;
  button {
    padding: 0px;
    padding-left: 3px;
    padding-right: 5px;
  }
  svg {
    font-size: 15px;
  }
`;

const useStyles = makeStyles((theme) => ({
  assetName: {
    width: "40%",
  },
}));

const initialFormValues = {
  pi_id: 1,
  ratio_term: 1,
  reverse: false,
  split_date: "2020-08-31",
  user_ids: [],
  apply_for_users: false,
};

export default function AddSplitForInstrument() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [isloading, setIsloading] = useState(false);
  const [userIds, setUserIds] = useState([]);
  const [userId, setUserId] = useState();

  const [formData, setFromData] = useState(initialFormValues);
  const [validate, setValidate] = useState(false);
  const [splitDate, setDateValues] = useState(moment());
  const [reverse, setReverse] = useState(false);
  const [apply_for_users, setApplyForUser] = useState(false);

  const handleChange = (e, val, field) => {
    e && e.persist();
    setFromData((prev) => ({
      ...prev,
      [field]: val || e?.target?.value || val,
    }));
  };

  const addUserIds = (val) => {
    if (val == 0 || !val || val === undefined || val === "") {
      enqueueSnackbar("Enter user Id", {
        variant: "error",
      });
      return;
    }
    if (val !== undefined) {
      const filterUser = userIds?.filter((user) => user === Number(val));
      if (filterUser?.length === 0) {
        setUserIds([...userIds, Number(val)]);
      } else {
        enqueueSnackbar("User Id already exist", {
          variant: "error",
        });
      }
    }
  };
  const removeUserIds = (index) => {
    const colneUserIds = [...userIds];
    colneUserIds.splice(index, 1);
    setUserIds(colneUserIds);
  };

  const UpdateCalculation = async () => {
    formData.reverse = reverse;
    formData.user_ids = userIds && userIds?.length > 0 ? userIds : null;
    formData.split_date = moment(splitDate).format("YYYY-MM-DD");
    setIsloading(true);
    try {
      const response = await AddSplitForInstrumentAction(formData);
      if (response?.success) {
        enqueueSnackbar(response?.message || "Success.", {
          variant: "success",
        });
        setUserIds([]);
        setIsloading(false);
      } else {
        enqueueSnackbar(response?.message || "Error.", {
          variant: "error",
        });
        setIsloading(false);
      }
    } catch (error) {
      if (error instanceof Error) {
        enqueueSnackbar(
          "API request is taking a while, please check Logs and DB to know the status.",
          {
            variant: "error",
          }
        );
        setIsloading(false);
      }
    }
  };

  return (
    <>
      {isloading && <Spinner />}
      <SettingSubTitle>Add split for instrument1231231</SettingSubTitle>
      <div>
        <FromWrapper>
          <div style={{ textAlign: "right" }}>
            <FormControlLabel
              control={
                <Switch
                  label="Reverse"
                  checked={reverse}
                  onChange={(e) => setReverse(e?.target?.checked)}
                  size="small"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
              label="Reverse"
            />
          </div>
          <FormItem
            required={true}
            type={"number"}
            id="pi_id"
            value={formData.pi_id}
            label={"PI ID"}
            handleChange={(e, val) => handleChange(e, val, "pi_id")}
            className={classes.assetName}
          />
          <FormItem
            required={true}
            type={"number"}
            id="pi_id"
            value={formData.ratio_term}
            label={"Ratio term"}
            handleChange={(e, val) => handleChange(e, val, "ratio_term")}
            className={classes.assetName}
          />

          <DateInput
            label="Date"
            //disableFuture
            defaultToday
            autoExpand
            format={DateFormat}
            value={splitDate}
            onChange={(val) => setDateValues((prev) => val)}
          />
          <div style={{ textAlign: "right" }}>
          asdasdsadassdassd
            <FormControlLabel
              control={
                <Switch
                  label="Apply for users"
                  checked={apply_for_users}
                  onChange={(e) => setApplyForUser(e?.target?.checked)}
                  size="small"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              }
              label="Apply for users"
            />
          </div>
          {apply_for_users && (
            <>
              <TextField
                value={isNaN(parseFloat(userId)) ? userId : parseFloat(userId)}
                label={"User id (After fill press enter key)"}
                size={"small"}
                type="number"
                onKeyPress={(event, val) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    addUserIds(event.target.value);
                  }
                }}
              />
              <UserIdList>
                {userIds &&
                  userIds?.length > 0 &&
                  userIds.map((val, index) => (
                    <UserIdItems key={index}>
                      {val}
                      <IconButton onClick={() => removeUserIds(index)}>
                        <CloseIcon />
                      </IconButton>
                    </UserIdItems>
                  ))}
              </UserIdList>
            </>
          )}
        </FromWrapper>

        <SettingButton
          variant="contained"
          size="small"
          onClick={UpdateCalculation}
        >
          Submit
        </SettingButton>
      </div>
    </>
  );
}
